import { Component, OnInit } from '@angular/core';
import { ArquivoService } from '../../shared/services/arquivo.service';
import {
  AbstractControl,
  FormArray,
  Validators,
  FormGroup,
  FormBuilder
} from '@angular/forms';
import { ConfirmationService } from 'primeng/primeng';
import { CandidatoService } from '../candidato.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/components/common/messageservice';
import { TipoArquivo } from './../../../models/tipoArquivo';

@Component({
  selector: 'sispac-enviar-termo-aditivo',
  templateUrl: './enviar-termo-aditivo.component.html',
  styleUrls: ['./enviar-termo-aditivo.component.css']
})
export class EnviarTermoAditivoComponent implements OnInit {

  form: FormGroup;
  idCandidato;
  tipoArquivo;
  idTipoArquivo:string;
  nomeDocumento;
  uploadUrl: string;

  arquivosToRemove = new FormArray([]);
  tiposAceitos: TipoArquivo[];
  listaTiposAceitos: TipoArquivo[] ;

  numeroVersaoArquivos: any;

  get arquivos() { return this.form.get('arquivos') as FormArray; }
  get IdCandidato() { return this.form.get('idCandidato'); }

  constructor(
    private arquivoService: ArquivoService,
    private fb: FormBuilder,
    private _router: Router,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private candidatoService: CandidatoService,
    private messageService: MessageService) {

      this.route.paramMap.subscribe(params =>
        this.idCandidato = params.get('idCandidato')
      );

      this.form = fb.group({
        idCandidato: [this.idCandidato],
        idTipoArquivo: [null],
        dataAssinaturaTermoAditivo:[''],
        arquivos: new FormArray([])
      });
     }

  ngOnInit() {
    this.popularTiposAceitos();
  }

  popularTiposAceitos(){


    this.candidatoService.getVersaoTermoAditivoAtual(this.idCandidato)
          .subscribe(versao => {

            versao++;//Atualiza versão

            if(versao == null){
              versao = 1;
              this.numeroVersaoArquivos = 1;
            }
            else{
              this.numeroVersaoArquivos = versao;
            }


            this.listaTiposAceitos = [];
            this.listaTiposAceitos.push({tipo:"Termo Aditivo Aluno Assinado - Versão "+versao,numeroVersao:versao,idTipo:"58FF0E5D-69CD-4876-B116-D7F1FBBD067E", mostrar:true});
            this.listaTiposAceitos.push({tipo:"Nota Técnica do Termo aditivo - Versão "+versao,numeroVersao:versao,idTipo:"683F2625-A3F5-4887-9547-B000F72B5B79",mostrar:true});
            this.listarTiposAceitos();
          });

          console.log(this.listaTiposAceitos);

 }

  listarTiposAceitos(){
    var tipos = this.listaTiposAceitos.filter(obj => obj.mostrar == true );

    this.tiposAceitos = tipos;
  }

  adicionaArquivo(idArquivo, nomeArquivo, isOld: boolean, idTipoArquivo,nomeTipo) {
    //this.isLoading = false;

    const arquivoFormGroup = this.fb.group({
      idArquivo: idArquivo,
      nomeTipo:nomeTipo,
      nomeArquivo: nomeArquivo,
      idTipoArquivo: idTipoArquivo,
      isOld: isOld,
      numeroVersao: this.numeroVersaoArquivos
    });
    this.arquivos.push(arquivoFormGroup);

    this.mostrarTipoArquivoAceito(idTipoArquivo,false);

    this.form.controls['idTipoArquivo'].setValue('');
  }

  mostrarTipoArquivoAceito(idTipoArquivo,mostrar){
    var item = this.listaTiposAceitos.filter(obj => obj.idTipo == idTipoArquivo)[0];
    var index = this.listaTiposAceitos.indexOf(item);
    this.listaTiposAceitos[index].mostrar = mostrar;
    this.listarTiposAceitos();
  }

  onSelect(item) {
    switch (item.target.value) {
      case '58FF0E5D-69CD-4876-B116-D7F1FBBD067E':
        this.tipoArquivo =  'termoAditivoAlunoAssinado';
        this.nomeDocumento = 'Termo Aditivo Aluno Assinado';
        break;
      case '683F2625-A3F5-4887-9547-B000F72B5B79':
        this.tipoArquivo =  'notaTecnicaTermoAditivoAluno';
        this.nomeDocumento = 'Nota Técnica do Termo aditivo';
        break;
      default:
        this.tipoArquivo = '';
        this.nomeDocumento = '';
    }

    this.uploadUrl = this.arquivoService.uploadUrl + this.tipoArquivo ;
  }

  removeArquivo(arquivo: FormGroup) {
    this.arquivosToRemove.push(arquivo);

    const index = this.arquivos.controls.indexOf(arquivo);
    this.arquivos.removeAt(index);

    this.mostrarTipoArquivoAceito(arquivo.controls['idTipoArquivo'].value,true);
  }

  submit() {

    if (this.form.value.arquivos.length < 2) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Para salvar você deve enviar O Termo Aditivo do Aluno Assinado e a Nota Técnica do Termo Aditivo'
      });
      return;
    }



    if (this.form.value.dataAssinaturaTermoAditivo == '') {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Informe a data de assinatura do termo aditivo'
      });
      return;
    }

    this.confirmationService.confirm({
      message: 'Deseja enviar o termo aditivo deste candidato?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
          this.candidatoService.enviarTermoAditivoAssinado(this.form.value)
          .subscribe(candidato => {
            this.messageService.add({
              severity: 'success',
              summary: 'Atenção',
              detail: 'Termo Aditivo Enviado com sucesso'
            });

            this.confirmationService.confirm({
              message: 'Deseja cadastrar um novo termo aditivo?',
              header: 'Confirmação',
              icon: 'fa fa-question-circle',
              accept: () => {
                window.location.reload();
              },
              reject:() => {
                this._router.navigate(['/gerenciar-etapas']);
              }
            });

          });
        }
      });
    }

    cancelar() {
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja cancelar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.removeArquivosDoBanco(this.arquivos.controls);
          this.removeArquivosDoBanco(this.arquivosToRemove.controls);
          this._router.navigate(['/gerenciar-etapas']);
        }
      });
    }

    removeArquivosDoBanco(arquivos: AbstractControl[]) {
      arquivos.forEach(arquivo =>
        this.arquivoService.removeArquivo(arquivo.value.idArquivo)
          .subscribe(() => {

          })
      );
    }

  }






// WEBPACK FOOTER //
// ./src/app/components/candidato/enviar-termo-aditivo/enviar-termo-aditivo.component.ts